var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4444 14H1.55556C0.696446 14 0 13.3036 0 12.4444V1.55556C0 0.696446 0.696446 0 1.55556 0H12.4444C13.3036 0 14 0.696446 14 1.55556V12.4444C14 13.3036 13.3036 14 12.4444 14ZM1.55556 1.55556V12.4444H12.4444V1.55556H1.55556ZM11.6667 10.8889H2.33333L4.66667 7.77778L5.44444 8.55556L7.77778 5.44444L11.6667 10.8889ZM4.27778 6.22222C3.63345 6.22222 3.11111 5.69989 3.11111 5.05556C3.11111 4.41122 3.63345 3.88889 4.27778 3.88889C4.92211 3.88889 5.44444 4.41122 5.44444 5.05556C5.44444 5.69989 4.92211 6.22222 4.27778 6.22222Z",
    fill: "#636974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAlt);
export default __webpack_public_path__ + "static/media/image_alt.c5d37fee7fee383c5034dfc9ee4d35c9.svg";
export { ForwardRef as ReactComponent };